import styled from 'styled-components';

const ListStyle = styled.div`
	--recipesItemWidth: calc((100% / 4) - (var(--recipesItemGap) * 3) / 4);
	--emptyMarginB: calc(var(--sectionDistance) * 3);
	--emptyGap: var(--sp6x);

	/* margin-top: var(--recipesLargeDistance); */
	margin-top: var(--sectionDistance);

	.recipes-wrapper {
		opacity: 0;
	}

	.recipes-inner-wrapper {
		display: flex;
		flex-wrap: wrap;
		column-gap: var(--recipesItemGap);
		row-gap: var(--recipesItemDistance);
		margin-top: var(--recipesItemDistance);
	}

	.recipes-item-wrapper {
		width: var(--recipesItemWidth);
		display: flex;
		flex-direction: column;
		opacity: 0;
	}

	.recipes-item-link-wrapper {
		flex: 1;
	}

	.recipes-item-inner-wrapper {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.recipes-item-info-wrapper {
		flex: 1;
	}

	.recipes-item-info-inner-wrapper {
		height: 100%;
		justify-content: space-between;
	}

	.show-more-btn-wrapper {
		display: flex;
		justify-content: center;
		margin-top: var(--recipesItemDistance);
	}

	.empty-items-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: var(--emptyGap);
		margin: var(--sectionDistance) 0 var(--emptyMarginB);
	}

	.inner-wrapper-filter {
		#collapse-item {
			position: relative;

			#collapse-description {
				transition: var(--trTime) ease-out;
				position: absolute;
				top: 100%;
				width: 100%;
				z-index: 12;
				grid-template-rows: 1fr !important;
				transform: scale(0.4);
				transform-origin: 0% 0%;
				opacity: 0;
				pointer-events: none;

				.filter-content-inner-wrapper {
					background-color: var(--lightGray1000);
				}
			}

			&[status='open'] {
				#collapse-description {
					transform: scale(1);
					opacity: 1;
					pointer-events: all;
				}
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--emptyGap: var(--sp5x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--emptyGap: var(--sp4x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--emptyGap: var(--sp3x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--recipesItemWidth: calc((100% / 2) - (var(--recipesItemGap) * 1) / 2);
		--emptyGap: var(--sp2x);
	}
`;

export default ListStyle;
